import React, { useState, useCallback } from 'react';
import FullPageLoader from './FullPageLoader';

const useFullPageLoader = () => {
    const [loading, setLoading] = useState(false);

    const showLoader = useCallback(() => {
        setLoading(true);
    }, []);

    const hideLoader = useCallback(() => {
        setLoading(false);
    }, []);

    return [
        loading ? <FullPageLoader /> : null,
        showLoader,
        hideLoader
    ];
};

export default useFullPageLoader;
